import { APP } from 'src/Configs/App'
import { rtkApi } from 'src/Services/rtkApi'

import { mergeCampaignGenres } from './hepers'

export interface SimilarGenre {
  id: number
  genreName: string
}

export type GenreWithCurators = {
  genreName: string
  id: number
  curatorsCount: number
}

export type PopularGenres = {
  subTitle: string
  genres: GenreWithCurators[]
  extraGenres: GenreWithCurators[]
}

export interface MergedGenres {
  recommended: GenreWithCurators[]
  filteredAllGenres: GenreWithCurators[]
  allGenres: GenreWithCurators[]
  popularGenres: PopularGenres[]
}

const spotifyCampaignGenresApi = rtkApi.injectEndpoints({
  endpoints: (build) => ({
    getCampaignGenres: build.query<MergedGenres, string>({
      queryFn: async (campaignId, _queryApi, _extraOptions, fetchWithBQ) => {
        // get a list of genres from the server
        // and a list of similar genres from the tiktok server
        const [similarGenresResult, allGenresResult] = await Promise.allSettled(
          [
            fetchWithBQ({
              url: `${APP.TIKTOK_SERVER}/spotify-campaign/${campaignId}/similar-artist-genres`,
              method: 'GET',
            }),
            fetchWithBQ({
              url: `${APP.TIKTOK_SERVER}/artist/spotify-campaigns/genres`,
              method: 'GET',
            }),
          ],
        )

        const similarGenres =
          similarGenresResult.status === 'fulfilled' &&
          !similarGenresResult.value.error
            ? (similarGenresResult.value.data as SimilarGenre[])
            : []

        if (allGenresResult.status === 'rejected') {
          return { error: allGenresResult.reason || 'Failed to fetch genres' }
        }

        if (
          allGenresResult.status === 'fulfilled' &&
          allGenresResult.value.error
        ) {
          return { error: allGenresResult.value.error }
        }

        const allGenres = allGenresResult.value.data as GenreWithCurators[]

        return { data: mergeCampaignGenres(similarGenres, allGenres) }
      },
    }),
  }),
})

export const { useGetCampaignGenresQuery } = spotifyCampaignGenresApi
